import { z } from 'zod';
import { ApiCardType } from '@/core/generated/api';
import { requiredString, textWithinLimit } from '@/shared/lib/validation';

/** Проверяет настройки карточки услуги */
export const voxServiceSchema = z.object({
    name: textWithinLimit(100, 'Название должно содержать не больше 100 символов', { trim: true })
        .pipe(requiredString('Укажите название карточки')),
    description: z.string(),
    productId: z.string()
        .uuid('Выберите базовый продукт'),
    backgroundColor: z.string()
        .trim()
        .regex(/^#[0-9a-f]{6}$/i, 'Укажите цвет в формате #RRGGBB'),
    cardType: z.enum([ApiCardType.Big, ApiCardType.Small], { error: 'Выберите размер карточки' }),
    imageUrl: textWithinLimit(2048, 'Адрес изображения должен содержать не больше 2048 символов', { trim: true })
        .refine(value => !value || /^https?:\/\/[^\s]+$/i.test(value), 'Укажите HTTP- или HTTPS-адрес изображения'),
    index: z.number()
        .int('Порядок должен быть целым числом')
        .min(-32768)
        .max(32767),
    isShowServices: z.boolean(),
    isUnderDevelopment: z.boolean(),
});

/** Значения редактора карточки услуги */
export type VoxServiceValues = z.infer<typeof voxServiceSchema>;

